// ─── Context ──────────────────────────────────────────────────────────────────

import { BaseNode } from 'helpers/documents/types/base';
import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useMemo,
} from 'react';
import { useSelectMode } from './useSelectMode';
import { SelectionStore } from './SelectionStore';

type SelectModeContextValue = {
  store: SelectionStore;
  isSelectMode: boolean;
  setIsSelectMode: Dispatch<SetStateAction<boolean>>;
};

const SelectModeContext = createContext<SelectModeContextValue | null>(null);

export function SelectModeProvider({
  items,
  children,
}: {
  items: BaseNode[];
  children: React.ReactNode;
}) {
  const { store, isSelectMode, setIsSelectMode } = useSelectMode(items);

  const value = useMemo(
    () => ({ store, isSelectMode, setIsSelectMode }),
    [store, isSelectMode],
  );

  return (
    <SelectModeContext.Provider value={value}>
      {children}
    </SelectModeContext.Provider>
  );
}

export function useSelectModeContext() {
  const ctx = useContext(SelectModeContext);
  if (!ctx)
    throw new Error(
      'useSelectModeContext must be used within <SelectModeProvider>',
    );
  return ctx;
}
